import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  ResolveFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { combineLatest, Observable, of, throwError } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';

import { Activity } from '~/core/model/activity.model';
import { Timeslot } from '~/core/model/timeslot.model';
import { ActivityService } from '~/core/services/activity/activity.service';
import { OrganizerSharedOrganizationService } from '~/organizer/shared/services/organization/organization.service';

export const OrganizerSharedTimeslotResolver: ResolveFn<{
  activity: Activity;
  timeslot: Timeslot;
}> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  router: Router = inject(Router),
  activityService: ActivityService = inject(ActivityService),
  organizationService: OrganizerSharedOrganizationService = inject(
    OrganizerSharedOrganizationService
  )
): Observable<{ activity: Activity; timeslot: Timeslot }> => {
  const timeslotId = route.paramMap.get('id');
  const organization = organizationService.organization;

  return activityService.getTimeslot(timeslotId).pipe(
    mergeMap((timeslot) =>
      combineLatest([
        activityService.getActivity(timeslot.activityIdentifier),
        of(timeslot),
      ])
    ),
    tap(([activity]) => {
      if (activity.organizationIdentifier !== organization.identifier) {
        throw new Error('Unauthorized');
      }
    }),
    map(([activity, timeslot]) => ({
      activity,
      timeslot,
    })),
    catchError((error) => {
      console.error('TimeslotActivityResolver', error);
      router.navigateByUrl('/404');

      return throwError(() => error);
    })
  );
};
